import type { SVGProps } from 'react'
const SvgSyLampSolid = (props: SVGProps<SVGSVGElement>) => (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width={24} height={24} {...props}>
		<circle cx={12} cy={9} r={7} fillOpacity={0.24} />
		<path d="M9.75 8C8.79 8 8 8.79 8 9.75s.79 1.75 1.75 1.75h.75V14a.5.5 0 0 0 .5.5.5.5 0 0 0 .5-.5v-2.5h1V14a.5.5 0 0 0 .5.5.5.5 0 0 0 .5-.5v-2.5h.75c.96 0 1.75-.79 1.75-1.75S15.21 8 14.25 8s-1.75.79-1.75 1.75v.75h-1v-.75c0-.96-.79-1.75-1.75-1.75m0 1c.42 0 .75.33.75.75v.75h-.75c-.42 0-.75-.33-.75-.75S9.33 9 9.75 9m4.5 0c.42 0 .75.33.75.75s-.33.75-.75.75h-.75v-.75c0-.42.33-.75.75-.75" />
		<path
			fillRule="evenodd"
			d="M15 16.564a.154.154 0 0 0-.216-.14c-.853.37-1.795.576-2.784.576s-1.93-.205-2.784-.575a.154.154 0 0 0-.216.139V18.5a2.5 2.5 0 0 0 2.5 2.5h1a2.5 2.5 0 0 0 2.5-2.5z"
			clipRule="evenodd"
		/>
	</svg>
)
export default SvgSyLampSolid
